import * as types from '../../lib/actionTypes.es6';

const initialState = {
  loader: false,
  engine_flows: null,
  get_flows_error: null,

  flow_raw_loader: false,
  engine_flow_raw: null,
  get_flow_raw_error: null,

  publish_loader: false,
  successfully_published: null,
  publish_error: null,

  create_loader: false,
  successfully_created: null,
  create_error: null,
};

export default function engineFlowsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_ENGINE_FLOWS_REQUEST:
      return { ...state, loader: true, get_flows_error: null };
    case types.GET_ENGINE_FLOWS_SUCCESS:
      return { ...state, loader: false, engine_flows: action.payload, get_flows_error: null };
    case types.GET_ENGINE_FLOWS_FAIL:
      return { ...state, loader: false, get_flows_error: action.payload };

    case types.GET_ENGINE_FLOW_RAW_REQUEST:
      return { ...state, flow_raw_loader: true, engine_flow_raw: null, get_flow_raw_error: null };
    case types.GET_ENGINE_FLOW_RAW_SUCCESS:
      return { ...state, flow_raw_loader: false, engine_flow_raw: action.payload, get_flow_raw_error: null };
    case types.GET_ENGINE_FLOW_RAW_FAIL:
      return { ...state, flow_raw_loader: false, get_flow_raw_error: action.payload };
    case types.GET_ENGINE_FLOW_RAW_RESET:
      return { ...state, engine_flow_raw: null, get_flow_raw_error: null };

    case types.PUBLISH_ENGINE_FLOW_REQUEST:
      return { ...state, publish_loader: true, successfully_published: null, publish_error: null };
    case types.PUBLISH_ENGINE_FLOW_SUCCESS:
      return { ...state, publish_loader: false, successfully_published: action.payload, publish_error: null };
    case types.PUBLISH_ENGINE_FLOW_FAIL:
      return { ...state, publish_loader: false, successfully_published: null, publish_error: action.payload };
    case types.PUBLISH_ENGINE_FLOW_RESET:
      return { ...state, successfully_published: null, publish_error: null };

    case types.CREATE_ENGINE_FLOW_REQUEST:
      return { ...state, create_loader: true, successfully_created: null, create_error: null };
    case types.CREATE_ENGINE_FLOW_SUCCESS:
      return { ...state, create_loader: false, successfully_created: action.payload, create_error: null };
    case types.CREATE_ENGINE_FLOW_FAIL:
      return { ...state, create_loader: false, successfully_created: null, create_error: action.payload };
    case types.CREATE_ENGINE_FLOW_RESET:
      return { ...state, successfully_created: null, create_error: null };

    default:
      return state;
  }
}
